import { PRIORITAS_LABELS } from "../../data/programData";

const STYLES = {
  TINGGI: "bg-red-50 text-red-700 border-red-200",
  SEDANG: "bg-amber-50 text-amber-700 border-amber-200",
  RENDAH: "bg-slate-50 text-slate-600 border-slate-200",
};

export default function PrioritasBadge({ prioritas, className = "" }) {
  const style = STYLES[prioritas] || STYLES.SEDANG;
  return (
    <span
      data-testid={`prioritas-badge-${prioritas}`}
      className={`inline-flex items-center rounded border px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${style} ${className}`}
    >
      {PRIORITAS_LABELS[prioritas] || prioritas}
    </span>
  );
}
